module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-us":{"title":"Take a look at your score","subTitleGreat":"You\u0027re off to a great start, {name}","subTitleGood":"You\u0027re off to a good start, {firstName}","subTitleNeutral":"Here we go, {firstName}","message":"Keep building your score by getting more reviews.","requestReview":"Request a review"}}')
  delete Component.options._Ctor
}
